import api from "./axios";

export const getCityByZip = async (zip: string) => {
  return api.get(`/city/by-zip/${zip}`);
};

export const searchCities = async (searchKeyword: string) => {
  return api.get(`/city/search`, {
    params: {
      keyword: searchKeyword,
    },
  });
};

export const getCityByCoordinates = async (lat: string, lng: string) => {
  return api.get(`/city/nearby`, {
    params: {
      lat: lat,
      lng: lng,
    },
  });
};
